<template>
  <footer class="footer">
    <div class="social-media-links">
      <a href="https://www.instagram.com/apolotech.on/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
        <i class="fab fa-instagram social-icon"></i>
      </a>
      <a href="https://www.linkedin.com/in/codec-solu%C3%A7oes-4bb179386/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
        <i class="fab fa-linkedin-in social-icon"></i>
      </a>
        <a href="https://github.com/CODECsolucoestech" target="_blank" rel="noopener noreferrer" aria-label="GitHub">
        <i class="fab fa-github social-icon"></i>
      </a>
    </div>

    <div class="footer-bottom">
      <div class="logo-group">
        <a href="https://www.instagram.com/codecsolucoestecnologicas/" target="_blank" rel="noopener noreferrer">
          <img
            src="@/assets/Images/logoCodec.jpeg"
            alt="LogoCodec"
            class="circular-image"
          />
          <span class="logo-text">© CODEC Soluções Tecnológicas.</span>
        </a>
      </div>
      
      
      <p class="copyright-text">© 2025 Apolotech. Todos os direitos reservados.</p>
    </div>
  </footer>
</template>

<script>
export default {
  name: "SiteFooter",
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;700&display=swap');

* {
  font-family: Poppins, sans-serif;
}

.footer {
  background-color: rgb(149, 193, 240); /* Cor mais escura para combinar com a imagem */
  color: rgb(0, 0, 0);
  padding: 20px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
}

.social-media-links {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-bottom: 20px;
}

.social-icon {
  font-size: 2rem;
  color: #000000;
  transition: transform 0.3s ease, color 0.3s ease;
}

.social-icon:hover {
  transform: scale(1.1);
  color: #000000;
}

.footer-bottom {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  text-align: center;
}

.logo-group {
  margin-bottom: 10px;
}

.logo-group a {
  display: flex;
  align-items: center;
  text-decoration: none;
  color: inherit;
  font-size: 1rem;
}

.circular-image {
  height: 50px;
  width: 50px;
  border-radius: 50%;
  object-fit: cover;
  margin-right: 10px;
}

.logo {
  height: 60px;
  width: auto;
}

.copyright-text {
  margin-top: 20px;
  font-size: 0.9rem;
  color: #000000;
}

/* Ajustes de responsividade para telas maiores */
@media (min-width: 768px) {
  .footer-bottom {
    flex-direction: row;
    justify-content: space-around;
  }
}
</style>